module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-BOOSTER-GREEN-5.5d966489.jpg";